import React, { useEffect, useState } from "react";
import { Card, Div, Text } from "../../../styles/Common";
import { Row, Col } from "antd";
import { theme } from "../../../styles/theme";
import pinIcon from "../../../assets/icons/map-pin.svg";
import { Select } from "../../../components/Select";
import { Input } from "../../../components/Input";
import useCountries from "../../Projects/hooks/useCountries";
import useStates from "../../Projects/hooks/useStates";
import ReactLoading from "react-loading";
import useOptions from "../../../core/hooks/useOptions";
import { getPhoneLengthByCountry } from "../../../utilities/helpers";

export const ProjectForm = ({
  projectForm,
  setProjectForm,
  projectErrorForm,
  setProjectErrorForm,
  companiesOptions,
  isLoading,
  editProject,
}) => {
  const { data: countries } = useCountries();
  const { data: states } = useStates(226);
  const [countriesOptions, setCountriesOptions] = useState([]);
  const [statesOptions, setStatesOptions] = useState([]);
  const options = useOptions(5);
  const { data: optionsList } = options;
  const [codeOptions, setCodeOptions] = useState([]);
  const [forceUpdate, setForceUpdate] = useState(false);

  useEffect(() => {
    if (optionsList?.groupSettings?.length > 0) {
      setCodeOptions(
        optionsList.groupSettings.map((ele) => ({
          value: ele.id,
          label: ele.code,
        }))
      );
    }
  }, [optionsList]);

  useEffect(() => {
    if (countries?.length > 0) {
      setCountriesOptions(
        countries?.map((ele) => ({
          value: ele.countryId,
          label: ele.countryName,
        }))
      );
    }
  }, [countries]);

  useEffect(() => {
    if (states?.length > 0) {
      setStatesOptions(
        states.map((ele) => ({
          value: ele.stateId,
          label: ele.stateName,
        }))
      );
    }
  }, [states]);

  const handleChange = (event) => {
    const { value, id } = event.target;

    const currentProjectForm = projectForm;
    const newErrorForm = projectErrorForm;

    currentProjectForm[id] = value;
    setProjectForm(currentProjectForm);

    newErrorForm[id].error = false;
    newErrorForm[id].message = "";
    setProjectErrorForm(newErrorForm);
    setForceUpdate(!forceUpdate);
  };

  const handleChangeNumber = (event) => {
    const { value, id } = event.target;

    const currentProjectForm = projectForm;
    const newErrorForm = projectErrorForm;

    currentProjectForm[id] = value.replace(/[^0-9]/g, "");
    setProjectForm(currentProjectForm);

    newErrorForm[id].error = false;
    newErrorForm[id].message = "";
    setProjectErrorForm(newErrorForm);
    setForceUpdate(!forceUpdate);
  };

  const handleSelect = (id, value) => {
    const currentProjectForm = projectForm;
    const newErrorForm = projectErrorForm;

    currentProjectForm[id] = value;
    setProjectForm(currentProjectForm);

    newErrorForm[id].error = false;
    newErrorForm[id].message = "";
    setProjectErrorForm(newErrorForm);
    setForceUpdate(!forceUpdate);
  };

  const countryCode = codeOptions?.find(option => option.value === projectForm?.projectManagerPhoneCodeId)?.label;
  const maxLength = getPhoneLengthByCountry(countryCode);

  return (
    <Card  
      width="60%" 
      style={{ padding: "25px 31px 29px 30px", flexDirection: "column" }}
    >
      {isLoading ? (
        <Div width="100%" height="100%" justify="center" align="center">
          <ReactLoading color={theme.colors.salmon} />
        </Div>
      ) : (
        <>
          <Text
            size={theme.fonts.size.h5}
            weight={theme.fonts.weight.medium}
            color={theme.colors.dark}
            style={{ alignSelf: "flex-start" }}
            mb="16px"
          >
            General Information
          </Text>
          <Row gutter={[32, 16]} style={{ width: "100%" }}>
            <Col md={12}>
              {companiesOptions?.length === 1 ? (
                <Input
                  id="companyId"
                  value={companiesOptions[0].label}
                  disabled
                />
              ) : (
                <Select
                  id="companyId"
                  onChange={(e) => handleSelect("companyId", e)}
                  value={projectForm.companyId}
                  placeholder="Company Name"
                  autoComplete="off"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  notFoundContent="Data not found"
                  showSearch
                  options={companiesOptions}
                  error={projectErrorForm.companyId.error}
                  helper={
                    projectErrorForm.companyId.error ? projectErrorForm.companyId.message : ""
                  }
                  style={{ width: "100%" }}
                  disabled={!editProject}
                />
              )}
            </Col>
            <Col md={12}>
              <Input
                id="ownerCompany"
                onChange={handleChange}
                value={projectForm.ownerCompany}
                placeholder="Owner Company"
                maxLength={150}
                error={projectErrorForm.ownerCompany.error}
                helper={
                  projectErrorForm.ownerCompany.error
                    ? projectErrorForm.ownerCompany.message
                    : ""
                }
                disabled={!editProject}
              />
            </Col>
            <Col md={12}>
              <Input
                id="projectAFE"
                onChange={handleChange}
                value={projectForm.projectAFE}
                placeholder="Project AFE"
                maxLength={150}
                error={projectErrorForm.projectAFE.error}
                helper={
                  projectErrorForm.projectAFE.error ? projectErrorForm.projectAFE.message : ""
                }
                disabled={!editProject}
              />
            </Col>
            <Col md={12}>
              <Input
                id="projectName"
                onChange={handleChange}
                value={projectForm.projectName}
                placeholder="Project Name"
                maxLength={150}
                error={projectErrorForm.projectName.error}
                helper={
                  projectErrorForm.projectName.error ? projectErrorForm.projectName.message : ""
                }
                disabled={!editProject}
              />
            </Col>
            <Col md={12}>
              <Input
                id="projectManager"
                onChange={handleChange}
                value={projectForm.projectManager}
                placeholder="Project Manager"
                maxLength={150}
                error={projectErrorForm.projectManager.error}
                helper={
                  projectErrorForm.projectManager.error
                    ? projectErrorForm.projectManager.message
                    : ""
                }
                disabled={!editProject}
              />
            </Col>
            <Col md={12}>
              <Input
                id="projectManagerEmail"
                onChange={handleChange}
                value={projectForm.projectManagerEmail}
                placeholder="Email"
                maxLength={150}
                error={projectErrorForm.projectManagerEmail.error}
                helper={
                  projectErrorForm.projectManagerEmail.error
                    ? projectErrorForm.projectManagerEmail.message
                    : ""
                }
                disabled={!editProject}
              />
            </Col>
            <Col md={6}>
              <Select
                id="projectManagerPhoneCodeId"
                onChange={(e) => handleSelect("projectManagerPhoneCodeId", e)}
                value={projectForm.projectManagerPhoneCodeId}
                options={codeOptions}
                placeholder="Code"
                disabled={!editProject}
              />
            </Col>
            <Col md={18}>
              <Input
                id="projectManagerPhone"
                onChange={handleChangeNumber}
                value={projectForm.projectManagerPhone}
                placeholder="Phone Number"
                maxLength={maxLength}
                error={projectErrorForm.projectManagerPhone.error}
                helper={
                  projectErrorForm.projectManagerPhone.error
                    ? projectErrorForm.projectManagerPhone.message
                    : ""
                }
                disabled={!editProject}
              />
            </Col>
          </Row>
          <Text
            size={theme.fonts.size.h5}
            weight={theme.fonts.weight.medium}
            color={theme.colors.dark}
            style={{ alignSelf: "flex-start" }}
            mt="32px"
            mb="16px"
          >
            Project Location
          </Text>
          <Row gutter={[32, 16]} style={{ width: "100%" }}>
            <Col md={12}>
              <Select
                id="country"
                onChange={(e) => handleSelect("country", e)}
                defaultValue={226}
                options={countriesOptions}
                disabled
                placeholder="Country"
              />
            </Col>
            <Col md={12}>
              <Select
                id="stateId"
                onChange={(e) => handleSelect("stateId", e)}
                value={projectForm.stateId}
                options={statesOptions}
                placeholder="State"
                error={projectErrorForm.stateId.error}
                helper={projectErrorForm.stateId.error ? projectErrorForm.stateId.message : ""}
                disabled={!editProject}
              />
            </Col>
            <Col md={18}>
              <Input
                id="address"
                onChange={handleChange}
                value={projectForm.address}
                placeholder="Address"
                suffix={<img alt="search" src={pinIcon} />}
                maxLength={150}
                error={projectErrorForm.address.error}
                helper={projectErrorForm.address.error ? projectErrorForm.address.message : ""}
                disabled={!editProject}
              />
            </Col>
            <Col md={6}>
              <Input
                id="addressZipCode"
                onChange={handleChange}
                value={projectForm.addressZipCode}
                placeholder="ZIP Code"
                maxLength={50}
                error={projectErrorForm.addressZipCode.error}
                helper={
                  projectErrorForm.addressZipCode.error
                    ? projectErrorForm.addressZipCode.message
                    : ""
                }
                disabled={!editProject}
              />
            </Col>
          </Row>
          <Text
            size={theme.fonts.size.h5}
            weight={theme.fonts.weight.medium}
            color={theme.colors.dark}
            style={{ alignSelf: "flex-start" }}
            mt="32px"
            mb="16px"
          >
            Or...
          </Text>
          <Row gutter={32} style={{ width: "100%" }}>
            <Col md={18}>
              <Input
                id="coordinates"
                onChange={handleChange}
                value={projectForm.coordinates}
                placeholder="Coordinates"
                suffix={<img alt="search" src={pinIcon} />}
                maxLength={150}
                error={projectErrorForm.coordinates.error}
                helper={
                  projectErrorForm.coordinates.error ? projectErrorForm.coordinates.message : ""
                }
                disabled={!editProject}
              />
            </Col>
            <Col md={6}>
              <Input
                id="coordinatesZipCode"
                onChange={handleChange}
                value={projectForm.coordinatesZipCode}
                placeholder="ZIP Code"
                maxLength={50}
                error={projectErrorForm.coordinatesZipCode.error}
                helper={
                  projectErrorForm.coordinatesZipCode.error
                    ? projectErrorForm.coordinatesZipCode.message
                    : ""
                }
                disabled={!editProject}
              />
            </Col>
          </Row>
        </>
      )}
    </Card>
  )
};
